<template lang="pug">
.non-scheduled-products
  p.section-title Non-scheduled products
  .panel(:class="!nonScheduledProducts.length ? 'empty' : ''")
    table(
      v-if="nonScheduledProducts.length"
      )
      thead
      tbody
        tr(v-for="(product, index) in nonScheduledProducts" :key="index")
          td.w-50(
            :data-test-id="`non-scheduled-product-name-${index}`"
            ) {{ product.ProductName }}
          td.quantity
            span.square(
              :data-test-id="`non-scheduled-product-quantity-${index}`"
              ) {{ product.ProductQuantity }}
          td.product
            span.square(
              :style="`background: ${product.ResourceColor}`"
              :data-test-id="`non-scheduled-resource-abbr-${index}`"
              ) {{ product.ResourceAbbreviation }}
            span.product-resource(
              :data-test-id="`non-scheduled-resource-name-${index}`"
              ) {{ product.ResourceName }}
    p(
      v-else
      ) No Products
</template>

<script>
export default {
  name: 'OverviewNonScheduledProducts',
  props: {
    nonScheduledProducts: {
      type: Array,
      default: null,
    },
  },
}
</script>

<style lang="stylus" scoped>
.booking-card-overview .non-scheduled-products .panel
  max-height 125px
  overflow-y scroll
  padding 15px

  table, tr, td
    border 0

    .quantity .square
      margin-right 0

  table
    width 100%

    tr
      vertical-align baseline

      td
        padding 0 0 15px

      .quantity
        width 20%
        text-align center

      .product-resource
        font-size 12px
        line-height 16px

    tr:last-child

      td
        padding 0
</style>
